import { nextTick } from 'vue'
import { revealDirective } from '@/directives/reveal'
import { observeSiteChrome, refreshPageReveal } from '@/utils/scrollReveal'

async function schedulePageReveal() {
  await nextTick()
  requestAnimationFrame(() => {
    refreshPageReveal()
  })
}

export default {
  install(app, { router } = {}) {
    app.directive('reveal', revealDirective)

    if (!router) return

    const runReveal = (route) => {
      if (route.meta?.isAdmin) return
      schedulePageReveal()
    }

    router.isReady().then(() => {
      runReveal(router.currentRoute.value)
      observeSiteChrome()
    })

    router.afterEach((to) => {
      runReveal(to)
    })
  },
}
